/* eslint-disable */

//todo this code needs some refactoring to make it easier to follow
//make makes it hard to debug in ie8 is that there is also a resize handler in index.js for ie8

var NewHeader = require('../src/components/react/PageHeader/NewHeader').default;

/*
 * API should
 * have some private vars
 * have some private functions
 * only expose useful functions
 * exposed functions should have a callback trigger an event on state change
 * exposed api should be a class that can be newed with its own scope
 * use this.var in API to pass the correct context
 * */

var sticky = (function(){

  var rect = {},
    settings = {
      basketMaxHeight: 500, //will be used when we have multi-channel baskets
      basketHeight: $('#product-actions').height(), //will be used when we have multi-channel baskets
      footerPosition: $('#footer').position().top
    };


  var isElementInView = function (el) {
    if (typeof $ === "function" && el instanceof $) {
      el = el[0];
    }
    var rect = el.getBoundingClientRect();
    return (
        rect.top >= 20 &&
        rect.left >= 0 &&
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && /*or $(window).height() */
        rect.right <= (window.innerWidth || document.documentElement.clientWidth) /*or $(window).width() */
      );
  };

  var makeElementsSticky = function (sidebarPositionLeft, elementName, element, wrapperWidth) {
    var isDeliveryDayCalendarDisplayed = document.querySelector('[data-component="delivery-day-calendar"]');
    if (elementName === '#product-actions.desktop' && isDeliveryDayCalendarDisplayed) {
      return;
    }

    var _window = $(window),
        _parent = element.closest('.product-page'),
        _parentBottomPosition = _parent.offset().top + _parent.innerHeight();

    if (!_parent.hasClass('sticky-container')) {
      _parent.addClass('sticky-container');
    }

    if (elementName === '#product-actions.desktop' && _parentBottomPosition - _window.scrollTop() <= element.outerHeight(true)) {
      element.css({'position':'absolute','top':'inherit','bottom':'0px','right':'0px', left: 'auto'});
      return;
    } else {
      element.removeAttr('style');
    }

    var rectProp = elementName,

    //TODO: options block either be populated with js or passed in at initialization
      options = {
        '#product-actions.desktop': {
          1240: {
            width: String(Math.floor(wrapperWidth * 0.25)) + 'px'
          },
          978: {
            width: String(Math.floor(wrapperWidth * 0.32)) + 'px'
          }
        },
        '.tabs-controller.desktop': {
          1240: {
            width: '908px',
            marginLeft: '-619px'
          },
          978: {
            width: '643px', // MCD-685: changed from 711px
            marginLeft: '-488px'
          }
        }
      };

    if ($.isEmptyObject(rect[rectProp])) {
      rect[rectProp] = element[0].getBoundingClientRect();
    }

    var actionsDesktopWidth = options[elementName][wrapperWidth].width;

    switch(elementName) {
      case '#product-actions.desktop':
      {
        element.css({
          'position': 'fixed',
          'top': '0px',
          'width': actionsDesktopWidth,
          'left': sidebarPositionLeft
        });
        break;
      }
      case '.tabs-controller.desktop':
      {
        element.css({
          'position': 'fixed',
          'top': '0',
          'left': '50%',
          'width': options[elementName][wrapperWidth].width,
          'margin-left': options[elementName][wrapperWidth].marginLeft
        });
        break;
      }
    }
  };

  var initialise = function (elements) {
    var _window = $(window),
        _elements = {},
        _wrapper = $('#wrapper'),
        _header = $(NewHeader.pageHeaderElementQuery)


    $.each(elements, function(index, value){
      _elements[index] = {
        name: elements[index],
        el : $(elements[index]),
        position : $(elements[index]).offset().top
      };
    });

    // Get correct position, after header is rendered
    _header.on(NewHeader.HEADER_RENDERED, function() {
      $.each(_elements, function (index, value) {
        _elements[index].position = _elements[index].el.offset().top
      });
    })

    _window.on('scroll resize', function(){
      $.each(_elements, function(index, value){
        if (_window.height() >=  _elements[index].el.height()){
          if (_window.scrollTop() > _elements[index].position && _window.width() > 1024){

            var wrapperMarginLeft = $('#wrapper').offset().left;

            var mainProductColumnWidth = parseInt($('#product-main')
              .css('width')
              .replace('px', ''));

            var sidebarPositionLeft = wrapperMarginLeft +
              mainProductColumnWidth;

            makeElementsSticky(
              sidebarPositionLeft,
              _elements[index].name,
              _elements[index].el,
              _wrapper.width()
            );

            _elements[index].el.trigger('positionChange');
          } else {
            _elements[index].el.removeAttr('style');
            _elements[index].el.parent().removeClass('sticky-container');
            _elements[index].el.trigger('positionChange');
          }
        } else {
          _elements[index].el.removeAttr('style');
        }
      });
    });

  };

  var initialiseCompare = function(element) {
    var timer;
    var direction;
    var lastScrollTop = 0;
    var delta = 5;
    var padding = 30;
    var stickyBoxHeight = element === '[data-component="compare-panel"]' ? 84 : $(element).outerHeight(true);
    var defaultTop = $(element).offset().top;
    var parentHeight = $(element).parent().outerHeight(true);

    $(window).on('load scroll resize', function(event) {
      hasScrolled(element, event);

      clearTimeout(timer);
      timer = setTimeout(stopScrolling, 350);
    });

    function stopScrolling() {
      if(direction === 'up' && lastScrollTop < parentHeight) {
        $(element)
          .removeClass('dc-sticky-hidden')
          .addClass('dc-sticky-sticked')
          .css('top', checkToolbarHeight());
      }
    };

    function checkToolbarHeight() {
      if ($(window).width() < 1025) {
        return $('[data-component="PageHeader"]').outerHeight(true) -
          $('header#header').outerHeight(true);
      } else {
        return 0;
      }
    }

    function checkOffset() {
      if(defaultTop > 0) {
        return (
          $(window).scrollTop()
            - (stickyBoxHeight + $('[data-component="PageHeader"]').outerHeight(true))
            - $('header#header').outerHeight(true)
            - 5 // margin at the bottom of comparePanel
        );
      } else {
        return 0;
      }
    }

    function hasScrolled(element, event) {
      var st = $(this).scrollTop();
      parentHeight = (
        $(element).parent()
          .find('div.row')
          .outerHeight(true) 
          + (stickyBoxHeight * 2)
      );

      if(event.type === 'load') {
        $(element).css('width', $(element).parent().outerWidth());
      }
      else if (event.type === 'resize') {
        $(element).css({
          'width': $(element).parent().outerWidth(),
          'top': checkToolbarHeight()
        });
      } else {
        if (('a#backTop').length) {
          $('a#backTop').on('click', function() {
            if($('body').hasClass('navActived')) {
              $(element).css({
                'top': 0,
                'position': '',
                'top': checkToolbarHeight()
              })
            }
          });
        }

        // scroll is bigger than delta
        if (Math.abs(lastScrollTop - st) <= delta)
          return;

        if (st > defaultTop && st === lastScrollTop) {
          $(element)
            .removeClass('dc-sticky-hidden')
            .addClass('dc-sticky-sticked');
        }

        if (st <= defaultTop) {
          direction = null;

          $(element)
            .removeClass('dc-sticky-hidden')
            .removeClass('dc-sticky-sticked')
            .css('top', 'auto');     
        } else if (lastScrollTop > st || lastScrollTop > parentHeight) {
          direction = 'up';

          $(element)
            .addClass('dc-sticky-hidden')
            .removeClass('dc-sticky-sticked')
            .css({
              'top': -(stickyBoxHeight + padding),
              'left': null
            });
        } else {
          direction = 'down';

          $(element)
            .removeClass('dc-sticky-hidden')
            .addClass('dc-sticky-sticked')
            .css({
              'top': checkToolbarHeight(),
              'left': null
            }); 
        }
      
        lastScrollTop = st;
      }
    }
    // Safari bug with fixed positioning
    $('a[href="#nav"]').on('click', function() {
      if($(window).scrollTop() > defaultTop) {
        if (!$('body').hasClass('navActived')) {    
          $(element).css({
            'position': 'absolute',
            'top': checkOffset()
          })
        } else {
          $(element).css({
            'top': 0,
            'position': '',
            'top': checkToolbarHeight()
          })   
        }
      }
    });
  };

  window.DCG.createNameSpace (window.DCG, 'DCG.Utilities');
  window.DCG.Utilities.isElementInView = isElementInView;

  return {
    initialiseCompare: initialiseCompare,
    initialise : initialise,
    isElementInView : isElementInView
  }

})();

module.exports = sticky;
